import React, { Component } from 'react';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import RkHeader from '../../../GeneralComponents/RkHeader'
import FormCreate from '../../../GeneralComponents/FormCreate'
import FormCreateFiles from '../../../GeneralComponents/FormGeneralFile'
import Preloader from '../../../GeneralComponents/LoadingComponen'
import { isMobile } from 'react-device-detect';
import IndexWeb from './TableIndexWeb'
import IndexMobile from './Mobile/Index'

class Table extends Component {
    constructor(props){
        super(props)
        const date = new Date();
        // getMonth() cuenta desde 0: sin el +1 la evaluación nueva se guardaba con un mes menos
        this.fecha = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            modal: false,
            idGeneralFile: "",
            modaFiles: false,

            ErrorValues: true,
            submitBtnFile: false,
            file: null,
            id: "",

            form: {
                name: "",
                description: "",
                type_normativity: this.props.type
            },

            formUpdate: {
                name: "",
                description: "",
                date_score: this.props.type == "NNOM" ? this.fecha : "",
                score: "",
            },

            formAddFiles: {
                modulo: "Normatividad",
                file: "",
                fileName: "",
                module_file_id: "",
            },

            dataFiles: [],
        }
    }

    messageSuccess = (response) => {
        Swal.fire({
          position: "center",
          type: `${response.type}`,
          title: `${response.success}`,
          showConfirmButton: false,
          timer: 1500,
        });
    };

    clearValues = () => {
        this.setState({
            form: {
                name: "",
                description: "",
                type_normativity: this.props.type
            }
        })
    }

    validationForm = () => {
        if (this.state.form.name != "") {
            this.setState({ ErrorValues: true })
            return true
        }else{
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleChange = (e) => {
        this.setState({
            form: {
              ...this.state.form,
              [e.target.name]: e.target.value
            }
        });
    }

    toogle = (from) => {
        if(from == "new"){
            this.setState({ modal: true})
            this.clearValues();
        }else{
            this.setState({ modal: false})
        }
    }

    HandleClick = () => {
        if(this.validationForm() == true){
            fetch("/health/normativity", {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.props.loadData();
                this.clearValues();
                this.setState({ modal: false})
                this.messageSuccess(data);
            });
        }
    }


    delete = id => {
        Swal.fire({
          title: "¿Estás seguro?",
          text: "¡El registro será eliminado para siempre!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#009688",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            fetch(`/health/normativity/${id}`, {
              method: "delete",
              headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
              }
            })
              .then(response => response.json())
              .then(response => {
                this.props.loadData()
                this.messageSuccess(response)
              });
          }
        });
    };

    //Update section

    edit = (rol) => {
        this.setState({
            id: rol.id,
            formUpdate: {
                name: rol.name,
                description: rol.description,
                date_score: this.props.type == "NNOM" ? this.fecha : "",
                score: this.props.type == "NNOM" ? rol.score : "",
            }
        })
    }

    HandleChangeUpdate = (e) => {
        this.setState({
            formUpdate: {
              ...this.state.formUpdate,
              [e.target.name]: e.target.value
            }
        });
    }

    HandleClickUpdate = () => {
        fetch(`/health/normativity/${this.state.id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(this.state.formUpdate), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.props.loadData();
            this.clearValues();
            this.setState({ id: ""})
            this.messageSuccess(data);
        });
    }

    getNameTitle = (name) => {
        // Nombre configurado por el tenant (Gestión Salud) si existe; si no, fallback.
        if (typeof window !== "undefined" && window.GS_TYPE_NAMES && window.GS_TYPE_NAMES[name]) {
            return window.GS_TYPE_NAMES[name];
        }
        if(name == "PCH" || name == "NMH"){
            return "Hospitales"
        }else if(name == "PCCAP"){
            return "Modelo Ambulatorio"
        }else if(name == "PCISO9001"){
            return "ISO 9001:2015 Salud"
        }else if(name == "PCISO15189"){
            return "ISO 7101:2023 HQM"
        }else if(name == "PCHEM"){
            return "Acreditación"
        }else if(name == "NCON"){
            return "Servicios Auxiliares"
        }else if(name == "NFAR"){
            return "Expediente Clínico"
        }else if(name == "NNOM"){
            return "Marco Legal"
        }
    }

    getColor = (calification) =>{
        if(calification < 6){
            return "color-red" 
        }else if(calification >= 6 && calification < 8 ){
            return "color-orange" 
        }else if(calification >= 8){
            return "color-green" 
        }
    }

    getScoreColorHex = (score) => {
        if (score < 6) return '#ea7470';
        if (score < 8) return '#ffa600';
        return '#22c488';
    }

    getScore = (value) => {
        if (value && value.length > 0) {
            const score = value[0].score;
            const bg = this.getScoreColorHex(score);
            return (
                <div className="rk-score-cell">
                    <span className="rk-score-pill" style={{ backgroundColor: bg }}>
                        {(score * 10).toFixed(1)}%
                    </span>
                    <span className="rk-score-cell__date">{value[0].date_score}</span>
                </div>
            );
        }
        return <span className="no-data-small">Sin calificación</span>;
    }

    //subir excel 

    uploadExel = (e) => {
        this.setState({
            file: e.target.files[0],
            submitBtnFile: (this.state.submitBtnFile == false ? true : false)
        });
    }

    handleClickUpload = () => {
        const formData = new FormData();
        formData.append("file", this.state.file)
        fetch(`/health/import_normativity/${this.props.type}`, {
            method: 'POST', // or 'PUT'
            body: formData, // data can be `string` or {object}!
            headers: {}
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.props.loadData();
            this.setState({ file: null, submitBtnFile: false })
            this.messageSuccess(data);
        });
    }

    //files 

    clearValuesFiles = () => {
        this.setState({
            formAddFiles: {
                ...this.state.formAddFiles,
                fileName: "",
                file: {},
            }
        })
    }

    addFiles = (normativity) => {
        this.loadDataFiles(normativity.module_file_id);
        this.setState({
            formAddFiles: {
                modulo: "Normatividad",
                file: {},
                fileName: "",
                module_file_id: normativity.module_file_id,
            },

            idGeneralFile: normativity.module_file_id,
            modaFiles: true,
        })
    }


    HandleChangeFiles = (e) => {
        this.setState({
            formAddFiles: {
                ...this.state.formAddFiles,
                [e.target.name]: e.target.value
            }
        });
    }

    toogleFiles = (from) => {
        if (from == "new") {
            this.setState({ modaFiles: true })
            this.clearValuesFiles();
        } else {
            this.setState({ modaFiles: false })
        }
    }

    loadDataFiles = (id) => {
        fetch(`/settings/get_general_files_normativity/${id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    dataFiles: data.data,
                    isLoadedFiles: false
                });
            });
    }

    handleFile = e => {
        this.setState({
            file: e.target.files[0]
        });
    };

    HandleClickFiles = () => {
        const formData = new FormData();
        formData.append("modulo", this.state.formAddFiles.modulo)
        formData.append("file", this.state.file)
        formData.append("fileName", this.state.formAddFiles.fileName)
        formData.append("module_file_id", this.state.formAddFiles.module_file_id)

        fetch(`/settings/general_files`, {
            method: 'POST', // or 'PUT'
            body: formData, // data can be `string` or {object}!
            headers: {}
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.clearValuesFiles()
                this.setState({ file: null })
                this.loadDataFiles(this.state.formAddFiles.module_file_id)
                this.messageSuccess(data);
            });
    }

    updateId = () => {
        this.setState({
            id: ""
        })
    }



    render() {
        return (
            <React.Fragment>

                <RkHeader
                    title={`${this.getNameTitle(this.props.type)}`}
                    subtitle={`Gestión de normatividad para ${this.getNameTitle(this.props.type)}`}
                    titleNew={"Nuevo requisito"}
                    icon="fas fa-clipboard-check"
                    onClickNew={this.toogle}
                    showNew={this.props.estados.crear}
                    showFilter={false}
                />

                <FormCreate
                    //modal props
                    backdrop={"static"}
                    modal={this.state.modal}
                    toggle={this.toogle}    
                    title={"Agregar nuevo requisito"}

                    //form props
                    formValues={this.state.form}
                    errorValues={this.state.ErrorValues}
                    onChangeForm={this.HandleChange}
                    submitForm={this.HandleClick}
                />

                {/* FormCreateFiles */}

                {this.state.modaFiles && (
                    <FormCreateFiles
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modaFiles}
                        toggle={this.toogleFiles}
                        title={"Agregar Archivos"}

                        //form props
                        formValues={this.state.formAddFiles}
                        onChangeForm={this.HandleChangeFiles}
                        submitForm={this.HandleClickFiles}

                        //table files 

                        dataFiles={this.state.dataFiles}
                        handleFileChange={this.handleFile}

                        //load info

                        loadDataTable={this.test}
                        loadDataFiles={this.loadDataFiles}
                        idGeneralFile={this.state.idGeneralFile}
                        module_file_id={this.state.formAddFiles.module_file_id}
                    />
                )}
                
                {this.props.estados.importFiles && (
                    <div className="rk-toolbar">
                        <label htmlFor="fathers" className="rk-btn rk-btn--soft">
                            <i className="fas fa-file-excel"></i> Cargar excel
                        </label>

                        <input
                            type="file"
                            id="fathers"
                            accept=".csv,.xls,.xlsx"
                            onChange={(e) => this.uploadExel(e)}
                            style={{ display: "none" }}
                        />

                        {this.state.submitBtnFile && (
                            <button onClick={() => this.handleClickUpload()} className="rk-btn rk-btn--primary">
                                Subir <i className="fas fa-file-upload"></i>
                            </button>
                        )}
                    </div>
                )}

                {this.props.isLoaded == true ? (
                    <React.Fragment>
                        {isMobile ? (
                            <IndexMobile 
                                data={this.props.data}
                                type={this.props.type}
                                getScore={this.getScore}
                                getColor={this.getColor}
                                addFiles={this.addFiles}
                                
                                //form update

                                id={this.state.id}
                                updateId={this.updateId}
                                HandleChangeUpdate={this.HandleChangeUpdate}
                                formUpdate={this.state.formUpdate}

                                edit={this.edit}
                                delete={this.delete}

                                HandleClickUpdate={this.HandleClickUpdate}
                                estados={this.props.estados}
                            />
                        ) : (
                            <IndexWeb
                                data={this.props.data}
                                type={this.props.type}
                                getScore={this.getScore}
                                getColor={this.getColor}
                                getNameTitle={this.getNameTitle}
                                addFiles={this.addFiles}

                                //form update

                                id={this.state.id}
                                updateId={this.updateId}
                                HandleChangeUpdate={this.HandleChangeUpdate}
                                formUpdate={this.state.formUpdate}

                                edit={this.edit}
                                delete={this.delete}
                                
                                HandleClickUpdate={this.HandleClickUpdate}
                                estados={this.props.estados}
                            />
                        )}
                    </React.Fragment>
            ) : (
                    <div className="col-md-12 text-center">
                        <Preloader />
                    </div>
                )
            }

            </React.Fragment>
        );
    }
}

export default Table;